import { useMutation } from '@tanstack/react-query';

import { QuestionnairesApi } from 'api';
import { FI_TASK_KEY } from 'hooks/keys';
import { useUser } from 'hooks/queries/useUser';
import { useFiTaskCache } from '../useFiTaskCache';

interface DeleteQuestionnaireResultParams {
  taskId: string;
  crbId: string;
  templateResultId: string;
}

/** Deletes one account's questionnaire out of a distribution. */
export function useDeleteQuestionnaireResult() {
  const { userBankId } = useUser();
  const { invalidateTaskDetails, removeTask } = useFiTaskCache();
  const questionnairesApi = new QuestionnairesApi();

  const { mutateAsync: deleteQuestionnaireResult, isPending: isDeleteQuestionnaireResultPending } =
    useMutation({
      mutationKey: [FI_TASK_KEY],
      mutationFn: ({ crbId, templateResultId }: DeleteQuestionnaireResultParams) =>
        questionnairesApi.deleteQuestionnaireResult(userBankId, crbId, templateResultId),
      onSuccess: (_, { taskId }) => {
        removeTask(taskId);
        invalidateTaskDetails([taskId]);
      },
      meta: {
        snackbarSuccessMessage: 'Distributed questionnaire has been successfully deleted.',
        snackbarErrorMessage:
          'There was an issue deleting the Account. Please verify it still exists or try again later.'
      }
    });

  return { deleteQuestionnaireResult, isDeleteQuestionnaireResultPending };
}
